/**
 * Shared two-column shell for the native-auth secondary screens (password reset,
 * OTP). Mirrors the login layout: light left panel with the CELESTE logo, navy
 * right panel with the star watermarks + branding. No language switcher here —
 * switching reloads the page, which would drop the in-flight reset/OTP state.
 */
import {ReactNode, useEffect} from 'react';
import {useIntl} from 'react-intl';

import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import './native-auth.css';

const STYLESHEETS = [
  'https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800',
  'https://login.celeste.fr/azure-template/v2/main.css',
  'https://login.celeste.fr/azure-template/v2/azureform.css',
];

const LOGO_DARK = toAbsoluteUrl('/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png');
const LOGO_WHITE = toAbsoluteUrl('/media/logos/LOGO_CELESTE_Sans_Baseline_Blanc.png');
const STAR_BG = 'https://login.celeste.fr/azure-template/star.svg';

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout = ({children}: AuthLayoutProps): JSX.Element => {
  const intl = useIntl();

  useEffect(() => {
    const links = STYLESHEETS.map((href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.nativeAuth = 'true';
      document.head.appendChild(link);
      return link;
    });
    return () => links.forEach((link) => link.remove());
  }, []);

  return (
    <div id="root" className="native-auth">
      <div className="native-shell">
        {/* Left panel */}
        <div className="native-left">
          <div className="native-topbar">
            <img className="native-logo" src={LOGO_DARK} alt="CELESTE" />
          </div>
          <div className="native-form-col">{children}</div>
        </div>

        {/* Right panel */}
        <div className="native-right">
          <img className="native-right-star" src={STAR_BG} alt="" aria-hidden="true" />
          <img
            className="native-right-star native-right-star-2"
            src={STAR_BG}
            alt=""
            aria-hidden="true"
          />
          <div className="native-right-inner">
            <img className="native-right-logo" src={LOGO_WHITE} alt="Espace client Celeste" />
            <h1 className="native-right-title">
              {intl.formatMessage({id: 'AUTH.NATIVE.ESPACE_CLIENT'})}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
